import { assign } from "lodash";
import {
  FETCH_MEMBERS_REQUEST,
  FETCH_MEMBERS_SUCCESS,
  FETCH_MEMBERS_FAILURE
} from "../types";

// const sameRequest = (state, payload) =>
//   state.status === payload.status &&
//   state.limit === payload.limit &&
//   state.offset === payload.offset &&
//   state.ordering === payload.ordering;

export default (
  state = {
    members: {
      loading: false,
      ids: [],
      id: 0
    }
  },
  action
) => {
  switch (action.type) {
    case FETCH_MEMBERS_REQUEST:
      return {
        ...state,
        members: assign({}, state.members, {
          id: action.payload.id,
          ids: [],
          loading: true
          // status: action.payload.status,
          // limit: action.payload.limit,
          // offset: action.payload.offset,
          // ordering: action.payload.ordering,
          // filters: action.payload.filters
        })
      };
    case FETCH_MEMBERS_SUCCESS:
      // if (sameRequest(state, action.payload)) {
      return {
        members: assign({}, state.members, {
          loading: false,
          ids: action.payload.items,
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous
        })
      };
    // }
    // return state;
    case FETCH_MEMBERS_FAILURE:
      return {
        members: assign({}, state.members, {
          loading: false
        })
      };
    // return state;
    default:
      return state;
  }
};
